// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"282":"398b35b27c1e9250","518":"a9c3fc2bc280b7d9","838":"9e6fea05291df7d7"}[chunkId] + ".js";
};